import { userStore } from '../store/userStore';

/**
 * Enterprise team-sharing gate for floorplans.
 * Reuses the same `shareDocuments` flag as multiplayer moodboards.
 */
export const canShareTeam = (): boolean => {
  if (userStore.isAdmin) return true;
  return (
    userStore.entitlements?.plan === 'ENTERPRISE' &&
    userStore.entitlements?.isActive === true &&
    userStore.featureFlags?.shareDocuments === true
  );
};
